import angular = require('angular');

import { NgCtrl } from './ng.controller';
import { NgConfig } from './ng.config';
import { NgRun } from './ng.run';

import 'angular-translate';
import 'angular-translate-loader-partial';

// Components
import AppSwitcher from './components/app-switcher/app-switcher';
import ProfileDropdown from './components/profile-dropdown/profile-dropdown';
import DropDownManager from './components/dropdown-manager/dropdown-manager.module';
import SpsNotificationsRoot from './components/sps-notifications-root/sps-notifications-root';
import SpsIntercomRoot from './components/sps-intercom-root/sps-intercom-root';

// Services
import TokenCheckService from './services/token-check.service';
import IconService from './services/icon.service';

// Directives
import TrackClick from './directives/track-click/track-click';

// Modals
import SubscriptionWarningModal from 'app/ng/modals/subscription-warning/subscription-warning';

const sps = window.sps || {};

const deps = [
  'pascalprecht.translate',
  TrackClick,
  AppSwitcher,
  ProfileDropdown,
  DropDownManager,
  TokenCheckService,
  IconService,
  SubscriptionWarningModal,
  SpsNotificationsRoot,
  SpsIntercomRoot
];

const app = angular
  .module('spsng', deps)
  .controller('AppCtrl', NgCtrl)
  .value('Utils', sps.Utils)
  .value('$Router', sps.$Router)
  .value('$Window', sps.$Window)
  .value('$Analytics', sps.$Analytics)
  .value('$Constants', sps.$Constants)
  .value('$CurrentUser', sps.$CurrentUser)
  .value('$IdentityResource', sps.$IdentityResource)
  .config(NgConfig)
  .run(NgRun).name;

  export {
    angular,
    app
  }